import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import routeInfo from './RouteUrlInfo.json';
import INFO from "../../utils/Enums.json";
import { HasPermissions, getToken } from "../../utils/Token";
import UnauthorizedAccess from '../UnauthorizedAccess';
import { useNavigate } from "react-router-dom";
// Create a context
const GlobalComponentContext = createContext();

export function useGlobalComponent() {
    return useContext(GlobalComponentContext);
}


const Test = routeInfo
export function GlobalComponentProvider({ children }) {
    const [currentActiveTab, setCurrentActiveTab] = useState(0);
    const [currentActiveSubTab, setCurrentActiveSubTab] = useState(0);
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {

        var details = Test[location?.pathname?.replace("/", "")];
        if (details) {
            setCurrentActiveTab(details?.MainTabIndex);
            setCurrentActiveSubTab(details?.SubTab);
        }

    }, [location]);
    const navigate = useNavigate();
    const isPathExcluded = [
        '/content',
        '/Lookupusername',//new one
        '/Help',
        '/EmailTemplateList',
        '/Registration',
        '/forgot-password',
        '/password-update',
        '/new-password',
        '/registration-option',
        '/registration-company',
        '/terms_and_conditions',
        '/Statement_of_Privacy',
        '/Contact_us',
        '/login',
        '/DashBoard',
        '/userdetails',
        '/UserDetails',
        '/EmployeesList',
        '/vendordetails',
        '/EmpSelfRegistration',
        '/EmployeeSelfRegistration',
        '/RecentDocuments',
        '/DashboardAnalytics',
        '/EmployeeSignature',
        "/payment",
        "/PaymentSuccess",
        '/PaymentsuccessForTraining',
        "/ClientVendorsInvited",
        '/CustomReports',
        '/Notification',
        '/Addticart',
        '/finacialData',
        '/Process/InviteVendor',
        "/Process/UserActivation",
        "/Process/FVInviteVendor",
        "/Common/ImportInvitationsToFV",
        "/EmployeeFirstLogin",
        "/recentDocuments",
        "/adminDocument",
        "/StatusDescription",
        '/checklists',
        "/CheckListDetails",
        '/CheckListQuestionDetail',
        "/ListOfPotentialClients",
        "/GetClientEmployees",
        "/EmployeeCheckinCode",
        // "/edituser",
        //"/VendorDetails",
        // '/EmployeeDocuments',
        '/LoginVerification',
        '/LoginEmailVerification',
        '/',


    ].includes(currentPath);
    const token = getToken();

    useEffect(() => {
        if (!token && !isPathExcluded) {
            navigate('/');
        }
    }, [token]);
    return (
        <GlobalComponentContext.Provider value={{ currentActiveTab, currentActiveSubTab }}>
            {isPathExcluded ? <>{children}</> : HasPermissions(
                currentPath.substring(1),
                INFO?.ScreenPermissions?.Read
            ) ? (
                children
            ) : (
                <UnauthorizedAccess />

            )}

        </GlobalComponentContext.Provider>
    );
}


